module.exports = __webpack_public_path__ + "static/media/redEmptyRoom.ab56d277.jpg";